import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dept-exam-sanction-form',
  templateUrl: './dept-exam-sanction-form.component.html',
  styleUrls: ['./dept-exam-sanction-form.component.css']
})
export class DeptExamSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-form/dept-exam-sanction-form.component.ts